<svelte:options tag="and-date-picker" ></svelte:options>
<script>
    import { createEventDispatcher } from "svelte";
    import { get_current_component } from "svelte/internal";
    import eventDispatcher from '../../../EventDispatcher';
    import Calender from "../Calendar.wc.svelte";
    import CalendarMonthYearNavBar from './CalendarMonthYearNavBar.wc.svelte';
  
    const component = get_current_component();
    const dispatch = createEventDispatcher();

    customElements.define('and-calendar-navigation', CalendarMonthYearNavBar);
    customElements.define('and-calendar', Calender);

    export let placeholder= "dd/mm/yyyy";
    let isAllowed = () => true;    
    export {isAllowed as isallowed};
    export let selected  = "";
    export let opencalendar = false;
    export let label = "";
    export let id = "and-date-picker";
    let currenDate= new Date();

    //ToDo Remove this hide fields(hideWeeklyView, hideDateCalendar) and handle view change only in calendar component - to toggle date/month/year view
    let hideWeeklyView = false;

    $: hideDateCalendar =  hideWeeklyView ? "true" : "";

    $:selectedDate = selected ? typeof selected == "object" ? selected : new Date(Date.parse(selected)) : '';

    $: inputText = selectedDate ?  selectedDate.toLocaleDateString() : '';

    let date, month, year, showDatePicker=false;

    $: {
      showDatePicker = opencalendar;
    }
  
    $: {
      date = selectedDate? selectedDate.getDate() : currenDate.getDate();
      month = selectedDate? selectedDate.getMonth() : currenDate.getMonth();
      year = selectedDate? selectedDate.getFullYear() : currenDate.getFullYear();
    }
  
    const showCalendar = () => {
      showDatePicker = true;
    };

    //ToDo Handle view change only in calendar component - to toggle date/month/year view
    function changeView(viewType) {
      hideWeeklyView = viewType !== 'date';
    }

    function changeMonth(selectedMonth) {
      month = selectedMonth && Object.keys(selectedMonth).length === 0 && selectedMonth.constructor === Object? 0 :selectedMonth;
    }

    function changeYear(selectedYear) {
        year = selectedYear;
    }

    const onDateChange = event => {
      showDatePicker = false;
      selectedDate = event.detail;
      dispatch("datechange", selectedDate);
      eventDispatcher.dispatchCustomEvent(component, new Event('datechange'), 'datechange', selectedDate);
    };


  </script>
  
  <style type="text/scss" lang="scss" >
    @import '../../../global.scss';
    
    .relative {
      position: relative;
      display: inline-flex;
    }
    .container {
      min-height: 350px;;
    }
    .box {
      position: absolute;
      top: 75px;
      left: 0px;
      border-radius: toRem(5px);
      border: 1px solid $and-charcoal;
      display: inline-block;
      overflow: hidden;
    }

    .label {
      font-family: "Poppins", sans-serif;
      @include fontSize(12px);
      color: $and-charcoal;
    }
  
    .month-name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 6px 0;
    }

    .nav-bar {
      min-width: 100%;
    }

    .input {
      font-family: "Poppins", sans-serif;
      border: 0.8px solid $and-charcoal;
      border-radius: toRem(5px);
      min-width: toRem(155px);
      min-height: toRem(40px);
      padding-left: toRem(16px);
      box-sizing: border-box;
      color: $and-charcoal;
      @include fontSize(16px);

      &:focus {
      outline: none !important;
      border: 0.8px solid $and-blue;
      }

      +i{ 
        @include gg-calendar;
        cursor: pointer;
        top: 37px;
      }
    }

  </style>


  
<div>
  <div class="relative">
    <div>
      <label class='label' for="{id}">{label}</label
        ><br />
      <input id={id} class='input' type="text" placeholder={placeholder} on:focus={showCalendar} value = {inputText} readonly>
      <i on:click={showCalendar}></i>
    </div>

    {#if showDatePicker}
      
      <div class="container">
        <div class="box">
          <div class="month-name">
            
            <and-calendar-navigation class='nav-bar'
                {month}
                {year}
                on:viewChange={e => changeView(e.detail)}
                on:monthSelected={e => changeMonth(e.detail)}
                on:yearSelected={e => changeYear(e.detail)}
              />
          </div>
          <and-calendar
            {month}
            {year}
            date={selectedDate ? selectedDate : new Date() }
            {isAllowed}
            hideWeeklyView={hideDateCalendar}
            on:datechange={onDateChange} />
        </div>
      </div>
    {/if}
  </div>
</div>
  